import { PublicClientApplication, EventType, InteractionRequiredAuthError } from '@azure/msal-browser';
import axios from 'axios';

import { Flex, Box, Button, createStandaloneToast } from '@chakra-ui/react';
import theme from '../theme';

import { createIntl, createIntlCache } from 'react-intl';
import en from '../lang/en.json';

const cache = createIntlCache();
const intl = createIntl({ locale: 'en', messages: en }, cache);

const config = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
        authority: process.env.REACT_APP_AUTH_AUTHORITY,
        redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
        postLogoutRedirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
        secureCookies: false,
    },
};

export const msalInstance = new PublicClientApplication(config);

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        msalInstance.setActiveAccount(event.payload.account);
    }
});

export const scopes = [process.env.REACT_APP_AUTH_SCOPE];

axios.interceptors.request.use(async (config) => {
    try {
        const { accessToken } = await msalInstance.acquireTokenSilent({ scopes, account: accounts[0] });

        config.headers.Authorization = `Bearer ${accessToken}`;
    } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
            msalInstance.loginRedirect();
        }
    }

    return config;
});

axios.interceptors.response.use(
    (response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        return response;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        if (error.response?.status === 401) {
            const toast = createStandaloneToast({ theme });
            const continueLabel = intl.formatMessage({ id: 'common_continue' });

            if (!toast.isActive('noPermissionsToast')) {
                toast({
                    render: ({ onClose }) => (
                        <Flex
                            wrap="wrap"
                            align="center"
                            px={6}
                            py={4}
                            color="gray.800"
                            borderWidth="1px"
                            borderRadius="md"
                            bg="red.200"
                            borderColor="red.900"
                        >
                            <Box mr={6}>{error.response.data.error}</Box>

                            <Button
                                textTransform="capitalize"
                                ml="auto"
                                variant="secondary"
                                bg="white"
                                onClick={onClose}
                            >
                                {continueLabel}
                            </Button>
                        </Flex>
                    ),
                    position: 'top',
                    id: 'noPermissionsToast',
                });
            }
        }

        return Promise.reject(error);
    }
);
